const PersonalSocial = [
  {
    id: 1,
    icon: 'facebook-f',
    urlTo: 'https://www.facebook.com/DrGorAmirbekyan/'
  },

  {
    id: 2,
    icon: 'whatsapp',
    urlTo: 'http://whatsap.me/dr.goramirbekyan '
  },
  {
    id: 4,
    icon: 'instagram',
    urlTo: 'https://www.instagram.com/dr.goramirbekyan/'
  }
];
export default function(state = PersonalSocial, action) {
  return state;
}
